import { nordyAxios } from '@/nordy/api/client'

import {
  getOrCreateAttributionContext,
  toMixpanelAdditionalInfo
} from './mixpanelAttribution'

export async function syncMixpanelTrackingContext(): Promise<void> {
  const context = getOrCreateAttributionContext({
    url: new URL(window.location.href),
    referrer: document.referrer
  })
  const payload = toMixpanelAdditionalInfo(context, window.location.pathname)

  await nordyAxios.patch('/v1/auth/me/mixpanel-tracking-context', payload)
}
